{
  "fr": {
    "contact": {
      "actions": {
        "accept": "D'accord",
        "add": "Nouveau Contact",
        "add_type": "Ajouter {type}",
        "backInspirationLists": "Retour aux listes d'inspiration",
        "cancelNew": "Annuler",
        "deactivateEmployee": "Désactiver",
        "deleteCustomer": "Supprimer Client...",
        "deleteEmployee": "Supprimer Collègue...",
        "deleteLead": "Supprimer le prospect...",
        "deletePartner": "Supprimer Partenaire...",
        "delete_contact": "Supprimer",
        "edit": "Modifier",
        "impersonate": "Imiter",
        "impersonateStart": "Passez par le portail orange pour explorer le monde de {name}.",
        "impersonateStop": "Arrêter imitation",
        "invite": "Envoyer une invitation",
        "newTicket": "Nouvelle Conversation",
        "reactivateEmployee": "Reactivater",
        "resendInvitationEmail": "Renvoyer l'email d'invitation",
        "searchContact": "Rechercher Contact",
        "searchCustomer": "Rechercher Client",
        "searchEmployee": "Rechercher Collègue",
        "selectAll": "Sélectionnez tous les {total} contacts",
        "selectOption": "Sélectionner Option",
        "setProfilePicture": "Définir la photo de profil",
        "showall": "Montre tous",
        "unSelectAll": "Effacer la sélection."
      },
      "attributes": {
        "language": "Langue",
        "timezone": "Fuseau horaire",
        "title": "Titre"
      },
      "labels": {
        "address": "Adresse",
        "all": "Tous les contacts",
        "back_to_overview": "Retour à l'aperçu",
        "cannot_create_role": "Contactez un propriétaire pour créer un nouveau contact",
        "cannot_delete": "Impossible de supprimer cet utilisateur (intégration)",
        "company": "Organisation",
        "company_all": "Toutes les organisations",
        "contact_status": {
          "active": "Actif",
          "added": "Sans invitation",
          "all": "Chaque statut",
          "blocked": "Déactivé",
          "invited": "Invité",
          "status": "Statut"
        },
        "contact_type": "Type",
        "customer": "Clients",
        "customers": "Clients",
        "employee": "Collègues",
        "export_contacts": "Exporter contacts",
        "general": "Général",
        "impersonateInactiveProfile": "Cette personne géniale n'est pas encore active. Veuillez d'abord activer le client.",
        "invite": "Oui, inviter des contacts",
        "inviteProfileFirstCustomer": "Inviter le client d'abord pour envoyer un message, imiter ou renvoyer l'email d'invitation",
        "inviteProfileFirstPartner": "Inviter le partenaire d'abord pour imiter ou renvoyer l'email d'invitation",
        "last_login": "Dernière connexion",
        "last_seen": "vu pour la dernière fois",
        "last_seen_not_seen_yet": "pas encore vu",
        "lead": "Prospect",
        "name": "Nom",
        "name_or_email_address": "Nom ou adresse e-mail",
        "name_or_email_address_phone": "Nom, adresse électronique ou téléphone",
        "noContacts": "Pas de contacts",
        "no_contacts": "Aucun contact à exporter",
        "no_contacts_results": "Cette recherche n'a pas de résultats. Essayez d'autres filtres pour trouver la bonne personne.",
        "no_contacts_results_subtitle": "Cette recherche n'a pas de résultats. Essayez d'autres filtres pour trouver la bonne personne.",
        "no_contacts_results_title": "Aucun contact trouvé",
        "number_contacts": "Pas de contacts | 1 Contact | {count} contacts",
        "other": "Autre",
        "partner": "Partenaire",
        "partners": "Les partenaires",
        "project": "Projet",
        "secondary_contact": "Contact secondaire",
        "selectOne": "Sélectionnez au moins 1 contact",
        "selectProjectForImpersonation": "Pour quel projet voulez-vous imiter {customer_name}?",
        "selected": "{selected} contact sélectionné. | {selected} contact sélectionné.",
        "sorting": {
          "last_name": "Nom",
          "session_started_at": "Dernière connexion",
          "status": "Statut"
        },
        "totalSelected": "Tous les contacts {total} sont sélectionnés.",
        "units": "Unités"
      },
      "navigation": {
        "backToContacts": "Retour aux contacts"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Par nom ou adresse e-mail"
      },
      "validation": {
        "emailTaken": "L'adresse email a déjà été utilisée",
        "mustBeEmailAddress": "Doit être une adresse email",
        "requireEmailAddress": "Email requis"
      }
    }
  }
}
